import React from 'react';
import { Grid } from '@mui/material';
import type { ReportVisual } from '../../services/reportsApi';
import ReportManifestStatus from './ReportManifestStatus';
import ReportScorecard from './ReportScorecard';
import ReportSeverityMix from './ReportSeverityMix';
import ReportTimeline from './ReportTimeline';
import ReportTopNBar from './ReportTopNBar';

type ReportVisualsProps = {
  visuals?: ReportVisual[] | null;
  compact?: boolean;
  onOpenLink?: (href?: string) => void;
};

const ReportVisuals: React.FC<ReportVisualsProps> = ({ visuals, compact = false, onOpenLink }) => {
  const reportVisuals = Array.isArray(visuals) ? visuals.filter(Boolean) : [];
  if (reportVisuals.length === 0) return null;

  return (
    <Grid container spacing={compact ? 1.5 : 2} sx={{ mb: compact ? 1.5 : 2 }}>
      {reportVisuals.map((visual) => {
        let content: React.ReactNode = null;
        if (visual.type === 'scorecard') {
          content = <ReportScorecard visual={visual} compact={compact} />;
        } else if (visual.type === 'severity_mix') {
          content = <ReportSeverityMix visual={visual} compact={compact} />;
        } else if (visual.type === 'top_n_bar' || visual.type === 'stacked_bar' || visual.type === 'trend_line') {
          // `stacked_bar` and `trend_line` intentionally use the same compact fallback renderer
          // until dedicated report-specific chart components are warranted.
          content = <ReportTopNBar visual={visual} compact={compact} onOpenLink={onOpenLink} />;
        } else if (visual.type === 'timeline') {
          content = <ReportTimeline visual={visual} compact={compact} onOpenLink={onOpenLink} />;
        } else if (visual.type === 'manifest_status' || visual.type === 'readiness_matrix') {
          content = <ReportManifestStatus visual={visual} compact={compact} />;
        }
        if (!content) return null;

        const fullWidth = visual.type === 'timeline' || visual.type === 'readiness_matrix';
        return (
          <Grid item xs={12} md={fullWidth ? 12 : 6} key={visual.id}>
            {content}
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ReportVisuals;
